import Vue from 'vue'
import Router from 'vue-router'
import Aanmelden from "./components/Aanmelden"
import TijdsregistratieLijst from "./components/TijdsregistratieLijst"
import TijdsregistratieWijzigen from "./components/TijdsregistratieWijzigen"
import WwvTw from "./components/WwvTw"

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: TijdsregistratieLijst },
    { path: '/aanmelden', component: Aanmelden },
    { path: '/tr/:id', component: TijdsregistratieWijzigen, meta: { hasBackButton: true } },
    { path: '/nieuw/:datum', component: TijdsregistratieWijzigen, meta: { hasBackButton: true } },
    { path: '/wwv_tw/:datum', component: WwvTw, meta: { hasBackButton: true } },
    { path: '/checkout', component: TijdsregistratieWijzigen, meta: { hasBackButton: true } }
  ]
})
